var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgElders(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 21,
    height: 27,
    viewBox: "0 0 21 27",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#6D5990",
    d: "M16.276 25.654H3.49C1.562 25.654 0 24.156 0 22.308V3.345C0 1.498 1.562 0 3.49 0h12.786c1.927 0 3.489 1.498 3.489 3.345v18.963c0 1.848-1.562 3.346-3.489 3.346",
    transform: "translate(.631 .63)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#DE758C",
    d: "M12.757 11.346c-.214 0-.422.024-.622.067-.05-.096-.104-.189-.166-.276.488-.494.788-1.16.788-1.893 0-1.522-1.287-2.756-2.874-2.756-1.588 0-2.875 1.234-2.875 2.756 0 .734.3 1.399.789 1.893-.062.087-.116.18-.166.276-.2-.043-.409-.067-.623-.067-1.588 0-2.875 1.234-2.875 2.757 0 1.522 1.287 2.755 2.875 2.755.628 0 1.208-.197 1.68-.524L8.27 18.62c-.052.284.177.546.479.546h2.27c.301 0 .53-.262.478-.546l-.42-2.287c.474.327 1.052.524 1.681.524 1.588 0 2.875-1.233 2.875-2.755 0-1.523-1.287-2.757-2.875-2.757",
    transform: "translate(.631 .63)"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgElders);
export default __webpack_public_path__ + "static/media/elders.a013997e7a7c6eb5d7bcbe9a275bdc05.svg";
export { ForwardRef as ReactComponent };